import React from 'react';
/**
 * A form allows users to input information.
 */
export var Form = function Form(props) {
  var _ref = props.forgeDoc.props,
    _onSubmit = _ref.onSubmit;
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      _onSubmit();
    }
  }, props.forgeDoc.children.map(props.render));
};
export var FormContext = /*#__PURE__*/React.createContext(null);